import {getEventId} from '@wix/wix-events-commons-statics'
import {connect} from '../../runtime-context/context'
import {isOrderCompleted} from '../../../selectors/placed-order'
import {getReservationId} from '../../../selectors/reservation'
import {getSortedSelectedTickets} from '../../../selectors/selected-tickets'
import {isFixedPriceTicketSelected} from '../../../selectors/tickets'
import {
  getPurchasedPlans,
  getSelectedPaidPlan,
  hasPurchasedPlans,
  showPaidPlansPicker,
} from '../../../selectors/paid-plans'
import {DetailsPageAppProps} from '../../app/interfaces'
import {MembershipSelectorRuntimeProps} from './interfaces'
import {MembershipSelector as Presentation} from './membership-selector'

const mapRuntime = ({state, actions: {applyPlan}}: DetailsPageAppProps): MembershipSelectorRuntimeProps => ({
  eventId: getEventId(state.event),
  reservationId: getReservationId(state),
  purchasedPlans: getPurchasedPlans(state),
  selectedPlan: getSelectedPaidPlan(state),
  orderCompleted: isOrderCompleted(state.placedOrder.order),
  shouldShow:
    hasPurchasedPlans(state) &&
    showPaidPlansPicker(state) &&
    isFixedPriceTicketSelected(state.tickets, getSortedSelectedTickets(state)),
  applyPlan,
})

export const MembershipSelector = connect<{}, MembershipSelectorRuntimeProps>(mapRuntime)(Presentation)
